/**
 * Central configuration for SLAM Transfer Portal
 *
 * Uses environment variables for flexibility:
 * - REACT_APP_SERVER_BASE_URL: Backend API URL (default: production Cloud Run)
 * - Set to http://localhost:8080 for local development
 *
 * In Capacitor (iOS native), relative URLs won't work since the app runs
 * from capacitor://localhost. We force absolute URLs to the production backend.
 */
import { Capacitor } from '@capacitor/core';

// Server configuration
const SERVER_PORT = 4001;  // Backend API
const CLIENT_PORT = 3001;  // Frontend React app

// Production backend URL for native apps (capacitor:// can't use relative paths)
const NATIVE_BACKEND_URL = 'https://slamv3-359065791766.us-central1.run.app';

// Base URLs - prefer environment variable, fallback to same-origin (for fullstack deployment)
// For local dev, set REACT_APP_SERVER_BASE_URL=http://localhost:4000
// For fullstack Cloud Run (slamv2), leave empty to use relative paths via nginx proxy
const SERVER_BASE_URL = Capacitor.isNativePlatform()
  ? NATIVE_BACKEND_URL
  : (process.env.REACT_APP_SERVER_BASE_URL ||
     process.env.REACT_APP_BACKEND_URL ||
     '');

const SERVER_BASE_AGENT_URL = process.env.REACT_APP_AGENT_BASE_URL || SERVER_BASE_URL;

// API endpoints
const API_BASE_URL = `${SERVER_BASE_URL}/api`;
const COACH_API_BASE_URL = `${API_BASE_URL}/coach`;

// CopilotKit Runtime URL for AG-UI protocol
// This proxies through our Node.js backend to the Python ADK backend
const COPILOT_RUNTIME_URL = `${API_BASE_URL}/copilot`;

// API URL for services (same as SERVER_BASE_URL unless explicitly overridden)
const API_URL = process.env.REACT_APP_API_URL || SERVER_BASE_URL;

const config = {
  // Port configuration
  SERVER_PORT,
  CLIENT_PORT,

  // Base URLs
  SERVER_BASE_URL,
  API_URL,

  // API endpoints
  API_BASE_URL,
  SERVER_BASE_AGENT_URL,
  COACH_API_BASE_URL,
  COPILOT_RUNTIME_URL,

  // Other configurations
  API_TIMEOUT: 600000, // 10 minutes
};

export default config;